import { FamilyUnit, InsuredPeopleDto } from '@zorro/clients';

export const getFamilyUnitFromWhoIsEnrolled = (
  insured: InsuredPeopleDto | undefined,
  whoIsEnrolled: Set<string>
): { familyUnit: FamilyUnit; numberOfDependents: 1 | 2 | null } => {
  if (!insured) {
    return { familyUnit: FamilyUnit.EMPLOYEE_ONLY, numberOfDependents: null };
  }

  const hasSpouse = insured.spouse && whoIsEnrolled.has(insured.spouse.id);

  const dependents = insured.dependents.filter(({ id }) =>
    whoIsEnrolled.has(id)
  );
  let numberOfDependents: 1 | 2 | null;
  if (dependents.length === 1 || dependents.length === 2) {
    numberOfDependents = dependents.length;
  } else {
    numberOfDependents = null;
  }

  if (!hasSpouse && dependents.length === 0) {
    return { familyUnit: FamilyUnit.EMPLOYEE_ONLY, numberOfDependents };
  }
  if (!hasSpouse && dependents.length > 0) {
    return { familyUnit: FamilyUnit.EMPLOYEE_CHILD, numberOfDependents };
  }
  if (hasSpouse && dependents.length === 0) {
    return { familyUnit: FamilyUnit.EMPLOYEE_SPOUSE, numberOfDependents };
  }
  return { familyUnit: FamilyUnit.FAMILY, numberOfDependents };
};
